import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  HostBinding,
  Input,
  OnDestroy, Optional,
  QueryList
} from '@angular/core';
import { ScreenService } from '../../screen.service';
import { Container } from '../container';

@Component({
  selector: 'screen-item',
  template: `
    <ng-content></ng-content>
  `,
  styles: [
      `
      :host {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
    `
  ]
})
export class ScreenItemComponent {
  constructor() {

  }
}

@Component({
  selector: 'screen-set',
  templateUrl: './screen.set.component.html',
  styleUrls: ['./screen.set.component.less'],
  providers: [ScreenService]
})
export class ScreenSetComponent extends Container implements AfterViewInit, OnDestroy {

  private _initialized = false;
  private _screenContainer: HTMLElement;
  private _length = 0;

  private _autoLoop = false;
  private _interval = 20000;
  private _intervalHandle;

  @HostBinding('class.single') _single = true;

  current = 0;
  idleArray = [];

  @ContentChildren(ScreenItemComponent) items: QueryList<ScreenItemComponent>;


  @Input()
  set autoLoop(param: boolean) {
    this._autoLoop = !!param;
    if (this._initialized) {
      this._hackAutoplay();
    }
  }

  @Input()
  set interval(param: number) {
    if (Number.isInteger(param) && param > 5000 && this._interval !== param) {
      this._interval = param;
      if (this._intervalHandle) {
        this.stop();
        this.start();
      }
    }
  }

  private get width() {
    return this._elementRef.nativeElement.offsetWidth;
  }

  constructor(private _elementRef: ElementRef, @Optional() private _screenService: ScreenService) {
    super();
  }

  ngAfterViewInit() {
    this._screenContainer = this._elementRef.nativeElement.querySelector('.screen-container');

    setTimeout(() => {
      this._init();
    });

    this.addSubscription(() => {
      this.stop();
    });
    this.addSubscription(this.items.changes.subscribe(() => {
      this._init();
    }));
  }

  resize() {
    this._update();
  }


  /**
   * 快捷按钮事件处理函数
   * @param index
   */
  pointerClick(index) {
    this.stop();
    this.goPage(index);
  }

  /**
   * 开始播放  不管autoLoop的标志是true or false
   */
  start() {
    this.stop();
    this._intervalHandle = setInterval(() => {
      // 更新current
      this.current = (this.current + 1) % this._length;
      this._update();
    }, this._interval);
  }

  stop() {
    if (this._intervalHandle) {
      clearInterval(this._intervalHandle);
      this._intervalHandle = 0;
    }
  }

  previous() {
    const preIndex = this.current;
    this.current = preIndex === 0 ? this._length - 1 : preIndex - 1;
    this._update();
  }

  next() {
    const preIndex = this.current;
    this.current = (preIndex + 1) % this._length;
    this._update();
  }

  /**
   * 跳转到index索引处的图片，index从0开始计数
   * @param index
   */
  goPage(index) {
    this.current = index % this._length;
    this._update();
  }

  private _init() {
    if (this.items.length) {
      this._single = (this.items.length <= 1);
      this.idleArray = new Array(this._length = this.items.length).fill('a');
      this._hackAutoplay();
    }
    this._initialized = true;
  }

  private _hackAutoplay() {
    if (this._autoLoop) {
      this.start();
    }
  }

  private _update() {
    this._screenContainer.style.transform = `translateX(${-this.current * this.width}px)`;
  }
}
